import React, { useMemo, useCallback } from "react";
import { DrilldownList } from "../index";

const toFlatOptions = (nestedOptions) =>
  nestedOptions.map(({ children, ...rest }) => ({
    ...rest,
    hasChildren: Array.isArray(children) && children.length > 0,
  }));

const createGetChildLevel = (nestedOptions, value, isMulti, onChange) => {
  const lookup = new Map();
  for (const node of nestedOptions) {
    lookup.set(node._id ?? node.value, node);
  }

  return (option) => {
    const node = lookup.get(option._id ?? option.value);
    if (!node?.children?.length) return null;

    const childFlatOptions = toFlatOptions(node.children);
    const hasGrandchildren = node.children.some(
      (c) => Array.isArray(c.children) && c.children.length > 0
    );

    return {
      options: childFlatOptions,
      value,
      isMulti,
      onChange,
      ...(hasGrandchildren
        ? { getChildLevel: createGetChildLevel(node.children, value, isMulti, onChange) }
        : {}),
    };
  };
};

export const StaticDrilldownList = ({
  options: nestedOptions = [],
  value = [],
  isMulti = true,
  onChange,
  folderSelectionMode,
  baseZIndex,
  listStyle,
  genCustomSelectComp,
}) => {
  const rootOptions = useMemo(
    () => toFlatOptions(nestedOptions),
    [nestedOptions]
  );

  const hasAnyChildren = useMemo(
    () => nestedOptions.some((o) => Array.isArray(o.children) && o.children.length > 0),
    [nestedOptions]
  );

  const getChildLevel = useCallback(
    (option) => createGetChildLevel(nestedOptions, value, isMulti, onChange)(option),
    [nestedOptions, value, isMulti, onChange]
  );

  return (
    <DrilldownList
      options={rootOptions}
      value={value}
      isMulti={isMulti}
      onChange={onChange}
      getChildLevel={hasAnyChildren ? getChildLevel : undefined}
      folderSelectionMode={folderSelectionMode}
      baseZIndex={baseZIndex}
      listStyle={listStyle}
      genCustomSelectComp={genCustomSelectComp}
    />
  );
};
